
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import SubMenuCards from './SubMenuCards';

import CloudNative from '../Data/CloudNative.json'
import CustomEngineeringData from '../Data/CustomEngineering.json'
import DataAIData from '../Data/DataAI.json'
import HostCetricData from '../Data/HostCentric.json'
import IndustryX from '../Data/IndustryX.json'
import Interactive from '../Data/Interactive.json'
import PlatformsOracle from '../Data/PlatformsOracle.json'
import PlatformsOthers from '../Data/PlatformsOthers.json'
import PlatformsSAP from '../Data/PlatformsSAP.json'
import PlatformsMicrosoft from '../Data/PlatformsMicrosoft.json'
import IandF from '../Data/IandF.json'
import LowCode from '../Data/LowCode.json'
import PCS from '../Data/PCS.json'
import InfrasturctureEngi from '../Data/InfrasturctureEngi.json'
import Security from '../Data/Security.json'
import AMS from '../Data/AMSLearning.json'

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

 function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState('panel1');
  let [accordsName, setAccordsName] = React.useState('');
  const handleChange = (panel, accordName) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    setAccordsName(accordName);
  };


  var streamsData = AMS
    .concat(CustomEngineeringData)  
    .concat(CloudNative)
    .concat(HostCetricData)      
    .concat(DataAIData)     
    .concat(IndustryX)  
    .concat(IandF)      
    .concat(InfrasturctureEngi) 
    .concat(LowCode)
    .concat(PlatformsMicrosoft)
    .concat(PlatformsSAP)
    .concat(Security)        
    .concat(Interactive)     
    .concat(PCS)      
    .concat(PlatformsOracle)     
    .concat(PlatformsOthers)
    ;

  return streamsData.filter(p => p.Display === true).map((data) => {
    return (
      <div id="stream-sec">
        <Accordion square expanded={expanded === `panel1${data.id}`} onChange={handleChange(`panel1${data.id}`, data.Name)} >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1d-content" id="panel1d-header">
            <h3>{data.Name}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <SubMenuCards streams={data.streams.filter(p => p.Display === true)} AccordName={data.Default} />
          </AccordionDetails>
        </Accordion>
      </div>
    );
  });
}
export default CustomizedAccordions;